import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import styled from 'styled-components'
import get from 'lodash/get'
import set from 'lodash/set'
import orderBy from 'lodash/orderBy'
import find from 'lodash/find'
import sortBy from 'lodash/sortBy'
import toNumber from 'lodash/toNumber'
import last from 'lodash/last'

import moment from '../../lib/moment.js'

import { css } from '@emotion/core'
import { BeatLoader } from 'react-spinners'
import { Button, Container, Row, Col } from 'reactstrap'
import {
  modalAction,
  authAction,
  leaveGenerationAction,
  employeeAction,
  companyAction,
  lobAction,
} from './../../actions/'
import {
  modalSelector,
  authSelector,
  leaveGenerationSelector,
  employeeSelector,
  companySelector,
  lobSelector,
} from './../../selectors'
import {
  searchEmployees,
  checkModifiedBy,
  findCompanyName,
  findLOBName,
  createListOfYears,
} from '../../function'
import CustomModal from '../../components/modal'
import CustomModalMessage from '../../components/modal-message'
import Searchbar from '../../components/searchbar'
import withLayout from '../../helpers/withLayout'

import LeaveGenerationForm from '../../components/leave-generation'
import ExportModal from '../../components/leave-generation/ExportModal'
import LeaveGenerationTable from '../../components/table-leave-generation'

class LeaveGenerationPage extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    if (get(nextProps, 'getLeaveGenerationData')) {
      const generation = get(nextProps, 'getLeaveGenerationData.prettyLeaveGeneration')
      set(tempState, 'prettyLeaveGeneration', generation)
      const years = createListOfYears(get(nextProps, 'getLeaveGenerationData.prettyLeaveGeneration'))
      const thisYear = moment().year()
      set(tempState, 'years', years)
      set(tempState, 'year', thisYear)
      const temp = []
      const year = generation[thisYear] ? thisYear :
        last(sortBy(Object.keys(generation), [g => toNumber(g)]))
      generation[year].map(gen => {
        const g = {}
        g.leave_generation_id = gen.leave_generation._id
        g.name = gen.name
        g.total = gen.meta.total
        g.approved = gen.meta.approved
        g.pending = gen.meta.pending
        g.remaining = gen.meta.remaining
        g.start_date = moment(gen.leave_generation.start_date)
        g.end_date = moment(gen.leave_generation.end_date)
        temp.push(g)
        return gen
      })
      let updated = ''
      let updated_by = ''
      const leaveGenerations = get(nextProps, 'getLeaveGenerationData.leaveGenerations')
      leaveGenerations.map(leave => {
        if (updated === '' || moment(updated).isBefore(moment(leave.updated))) {
          updated = leave.updated
          updated_by = leave.updated_by
        }
        return leave
      })
      set(tempState, 'updated', updated)
      set(tempState, 'updated_by', checkModifiedBy(updated_by, prevState.employees))
      set(tempState, 'leave_generations', temp)
      nextProps.resetGetLeaveGeneration()
    }
    if (get(nextProps, 'editLeaveGenerationData.updatedLeaveGenerations')) {
      const access_token = localStorage.getItem('access_token')
      const status = get(nextProps, 'editLeaveGenerationData.status')
      const message = get(nextProps, 'editLeaveGenerationData.message')
      nextProps.getLeaveGeneration(prevState.leaveGenerationID, access_token)
      if (status !== 200) {
        nextProps.showModal('leaveGeneration', status, message)
      } else {
        nextProps.showConfirm('editSuccess', status, message)
      }
      nextProps.resetEditLeaveGeneration()
    }
    if (get(nextProps, 'getEmployeeData') !== prevState.employees) {
      set(tempState, 'employees', get(nextProps, 'getEmployeeData'))
      set(tempState, 'defaultEmployees', get(nextProps, 'getEmployeeData'))
    }
    if (get(nextProps, 'getCompanyData') !== prevState.companys) {
      set(tempState, 'companys', get(nextProps, 'getCompanyData'))
    }
    if (get(nextProps, 'getLOBData') !== prevState.lobs) {
      set(tempState, 'lobs', get(nextProps, 'getLOBData'))
    }
    if (get(nextProps, 'exportLeaveGenerationData')) {
      window.open(get(nextProps, 'exportLeaveGenerationData'))
      nextProps.resetExportLeaveGeneration()
    }
    if (get(nextProps, 'exportLeaveGenerationUserData')) {
      window.open(get(nextProps, 'exportLeaveGenerationUserData'))
      nextProps.resetExportLeaveGenerationUser()
    }
    if (get(nextProps, 'importLeaveGenerationData')) {
      const access_token = localStorage.getItem('access_token')
      const import_result = get(nextProps, 'importLeaveGenerationData')
      nextProps.showConfirm('confirmImport', 'Import Result', import_result)
      nextProps.getLeaveGeneration(prevState.leaveGenerationID, access_token)
      nextProps.resetImportLeaveGeneration()
    }
    return tempState
  }

  constructor(props) {
    super(props)
    this.state = {
      rowID: '',
      isSpan: false,
      isEdit: false,
      leaveGenerationID: '',
      prettyLeaveGeneration: null,
      employees: [],
      defaultEmployees: [],
      companys: [],
      lobs: [],
      years: [],
      leaveGeneration: [],
      leave_generations: [],

      name: '',
      emp_code: '',
      company: '',
      lob: '',
      year: '',
      start_date: null,
      end_date: null,
      updated: '',
      updated_by: '',
      search: '',
      sort_by: 'emp_code',
      sort_order: 'desc',

      export_modal: false,
    }
  }

  componentDidMount() {
    const access_token = localStorage.getItem('access_token')
    this.props.getAuth(access_token)
    this.props.getCompany(access_token)
    this.props.getLOB(access_token)
    this.props.getEmployee(access_token)
  }

  createListOfEmployees = () => {
    const temp = []
    const employees = get(this, 'state.employees')
    if (employees) {
      employees.map(employee => {
        if (!employee.is_system_admin) {
          const emp = {}
          emp.emp_code = employee.emp_code
          emp.name = `${employee.first_name} ${employee.last_name}`
          emp.first_name = employee.first_name
          emp.last_name = employee.last_name
          emp.nick_name = employee.nick_name
          emp.company = findCompanyName(employee.company_id, this.state.companys)
          emp.lob = findLOBName(employee.lob_id, this.state.lobs)
          emp._id = employee._id
          temp.push(emp)
        }
        return employee
      })
    }
    return temp
  }

  handleInput = (e) => {
    if (e.target.name === 'year') {
      const generation = this.state.prettyLeaveGeneration
      const temp = []
      generation[e.target.value].map(gen => {
        const g = {}
        g.leave_generation_id = gen.leave_generation._id
        g.name = gen.name
        g.total = gen.meta.total
        g.approved = gen.meta.approved
        g.pending = gen.meta.pending
        g.remaining = gen.meta.remaining
        g.start_date = moment(gen.leave_generation.start_date)
        g.end_date = moment(gen.leave_generation.end_date)
        temp.push(g)
        return gen
      })
      this.setState({
        [e.target.name]: e.target.value,
        leave_generations: temp,
        isEdit: false,
      })
    } else {
      const temp = this.state.leave_generations
      const generation = find(temp, {
        leave_generation_id: e.target.id,
      })
      if (generation === undefined) {
        const new_gen = {}
        new_gen.leave_generation_id = e.target.id
        if (e.target.name === 'start_date') new_gen.start_date = moment(e.target.value)
        else if (e.target.name === 'end_date') new_gen.end_date = moment(e.target.value)
        else new_gen.total = parseInt(e.target.value, 10)
        temp.push(new_gen)
      } else {
        const index = temp.findIndex((obj => obj.leave_generation_id === e.target.id))
        if (e.target.name === 'start_date') temp[index].start_date = moment(e.target.value)
        else if (e.target.name === 'end_date') temp[index].end_date = moment(e.target.value)
        else temp[index].total = e.target.value !== '' ? parseFloat(e.target.value, 10) : ''
      }
      this.setState({ leave_generations: temp })
    }
  }

  handleClickEdit = () => {
    this.setState({ isEdit: !this.state.isEdit })
  }

  handleClickRow = (span, id, editID) => {
    this.setState({
      isSpan: span,
      leaveGenerationID: id,
      rowID: editID,
      isEdit: false,
    })
    if (span) {
      const access_token = localStorage.getItem('access_token')
      this.props.getLeaveGeneration(id, access_token)
      const employee = find(this.createListOfEmployees(), {
        _id: id,
      })
      this.setState({
        name: employee.name,
        emp_code: employee.emp_code,
        nick_name: employee.nick_name,
        company: employee.company,
        lob: employee.lob,
      })
    }
  }

  handleSearch = (e) => {
    if (e.target.value === '') {
      this.setState({ employees: this.state.defaultEmployees, search: '' })
    } else this.setState({ search: e.target.value })
  }

  showDiscard = () => {
    if (this.state.isEdit) {
      this.props.showConfirm('confirmDiscard', 'Discard Changes', 'Are you sure you want to discard all changes ?')
    } else this.handleClickRow(false, '', '')
  }

  cancelDiscard = () => {
    this.props.hideConfirm('confirmDiscard')
  }

  handleDiscard = () => {
    this.cancelDiscard()
    this.handleClickRow(false, '', '')
  }

  submitForm = () => {
    const temp = []
    this.state.leave_generations.map(g => {
      temp.push({
        leave_generation_id: g.leave_generation_id,
        total: g.total,
        start_date: moment(g.start_date),
        end_date: moment(g.end_date),
      })
      return g
    })
    const payload = {
      leave_generations: temp,
    }
    const access_token = localStorage.getItem('access_token')
    this.props.editLeaveGeneration(this.state.leaveGenerationID, payload, access_token)
    this.setState({ isEdit: false })
  }

  sortBy = (type, order) => {
    this.setState({ sort_by: type, sort_order: order ? 'asc' : 'desc' })
  }

  sortGeneration = (data) => {
    if (this.state.sort_by === 'emp_code') return orderBy(data, ['emp_code'], [this.state.sort_order])
    else if (this.state.sort_by === 'company') return orderBy(data, ['company'], [this.state.sort_order])
    else if (this.state.sort_by === 'lob') return orderBy(data, ['lob'], [this.state.sort_order])
    else if (this.state.sort_by === 'name') return orderBy(data, ['name'], [this.state.sort_order])
    return data
  }

  toggleExportModal = () => {
    this.setState(state => ({
      export_modal: !state.export_modal,
    }))
  }

  exportAllMethod = year => {
    const access_token = localStorage.getItem('access_token')
    this.props.exportLeaveGeneration(year, access_token)
  }

  exportIndividualMethod = () => {
    const { leaveGenerationID, year } = this.state
    const access_token = localStorage.getItem('access_token')
    this.props.exportLeaveGenerationUser(leaveGenerationID, year, access_token)
  }

  render() {
    const IsAdminUser = get(this.props, 'authData.user.is_hr_admin_role')
    const IsSystemUser = get(this.props, 'authData.user.is_system_admin')
    const IsHRConfidentialUser = get(this.props, 'authData.user.is_hr_admin_confidential_role')
    const IsManagementUser = get(this.props, 'authData.user.is_management_role')

    const isAuthenticated = get(this.props, 'redirectAuth.isAuthenticated')
    || get(this.props, 'redirectGeneration.isAuthenticated')
    const redirect = get(this.props, 'redirectAuth.redirect')
      || get(this.props, 'redirectGeneration.redirect')
    if (redirect) {
      localStorage.clear()
      if (isAuthenticated) localStorage.setItem('bad_token', true)
      this.props.resetAuth()
      window.location = '/'
    }

    if (IsHRConfidentialUser !== undefined &&
      IsSystemUser !== undefined &&
      IsAdminUser !== undefined &&
      IsManagementUser !== undefined &&
      !(IsHRConfidentialUser || IsSystemUser || IsAdminUser || IsManagementUser)) window.location = '/home'

    const isFetching = get(this.props, 'getIsFetchingGeneration')
    || get(this.props, 'getIsFetchingCompany')
    || get(this.props, 'getIsFetchingLOB')
    || get(this.props, 'getIsFetchingEmployee')
    const button = (
      <div>
        <NewButton color="info" onClick={ this.exportIndividualMethod }><div>Export</div></NewButton>
        <NewButton color="success" onClick={ this.state.isEdit ? this.submitForm : this.handleClickEdit }>{this.state.isEdit ? 'Save' : 'Edit'}</NewButton>
      </div>
    )
    const buttonDiscard = (
      <div>
        <NewButton color="" onClick={ this.cancelDiscard }>Cancel</NewButton>
        <NewButton color="danger" onClick={ this.handleDiscard }>Discard</NewButton>
      </div>
    )
    const buttonClose = (
      <div>
        <NewButton color="info" onClick={ () => this.props.hideConfirm('confirmImport') }>Close</NewButton>
      </div>
    )
    const buttonOK = <Button color="success" onClick={ () => this.props.hideConfirm('editSuccess') }>OK</Button>
    return (
      /* eslint no-underscore-dangle: 0 */
      <Wrapper fluid>
        <Searchbar
          import={ (payload) => this.props.importLeaveGeneration(payload, localStorage.getItem('access_token')) }
          export={ this.toggleExportModal }
          handleSearch={ this.handleSearch }
          { ...this.state }
        />
        { isFetching &&
          <Overlay>
            <OverlayWrapper>
              <BeatLoader
                css={ css(`
                  position: absolute;
                  left: 50%;
                  top: 50%;
                `) }
                sizeUnit={ "px" }
                size={ 15 }
                color={ '#D44B49' }
                loading={ isFetching }
              />
            </OverlayWrapper>
          </Overlay>
        }
        <CustomModal
          hide={ () => this.props.hideModal('leaveGeneration') }
          show={ get(this.props, 'modalType') === 'leaveGeneration' }
          type={ get(this.props, 'modalStatus') }
          message={ get(this.props, 'modalMessage') }
        />
        <ExportModal
          isOpen={ this.state.export_modal }
          toggle={ this.toggleExportModal }
          exportMethod={ this.exportAllMethod }
        />
        <Row noGutters>
          <CustomModalMessage
            hide={ () => this.props.hideConfirm('editSuccess') }
            show={ get(this.props, 'confirmType') === 'editSuccess' }
            type={ get(this.props, 'confirmStatus') }
            message={ get(this.props, 'confirmMessage') }
            button={ buttonOK }
          />
          <CustomModalMessage
            hide={ this.cancelDiscard }
            show={ get(this.props, 'confirmType') === 'confirmDiscard' }
            type={ get(this.props, 'confirmStatus') }
            message={ get(this.props, 'confirmMessage') }
            button={ buttonDiscard }
          />
          <CustomModalMessage
            hide={ this.cancelImport }
            flag={ 'confirmImport' }
            show={ get(this.props, 'confirmType') === 'confirmImport' }
            type={ get(this.props, 'confirmStatus') }
            created={ get(this.props, 'confirmMessage.createdPLeave') }
            updated={ get(this.props, 'confirmMessage.updatedLeave') }
            errors={ get(this.props, 'confirmMessage.errors') }
            button={ buttonClose }
          />
          <Row noGutters>
            <Col>
              <LeaveGenerationTable
                handleInput={ this.handleInput }
                handleClickRow={ this.handleClickRow }
                sortBy={ this.sortBy }
                data={ this.sortGeneration(
                  this.createListOfEmployees().filter(searchEmployees, this.state.search)) }
                { ...this.state }
              />
            </Col>
            {
              this.state.isSpan &&
              <Col>
                <LeaveGenerationForm
                  handleInput={ this.handleInput }
                  button={ button }
                  { ...this.state }
                  handleClickRow={ this.handleClickRow }
                  handleLeaveType={ this.handleLeaveType }
                  showDiscard={ this.showDiscard }
                  cancelDiscard={ this.cancelDiscard }
                />
              </Col>
            }
          </Row>
        </Row>
      </Wrapper>
    )
  }
}

LeaveGenerationPage.propTypes = {
  showConfirm: PropTypes.func.isRequired,
  hideConfirm: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
  getAuth: PropTypes.func.isRequired,
  getCompany: PropTypes.func.isRequired,
  getLOB: PropTypes.func.isRequired,
  getEmployee: PropTypes.func.isRequired,
  getLeaveGeneration: PropTypes.func.isRequired,
  editLeaveGeneration: PropTypes.func.isRequired,
  exportLeaveGenerationUser: PropTypes.func.isRequired,
  importLeaveGeneration: PropTypes.func.isRequired,
  exportLeaveGeneration: PropTypes.func.isRequired,
  resetAuth: PropTypes.func.isRequired,
}

const mapStateToProps = (state, props) => createStructuredSelector({
  modalStatus: modalSelector.modalStatus,
  modalType: modalSelector.modalType,
  modalMessage: modalSelector.modalMessage,
  confirmStatus: modalSelector.confirmStatus,
  confirmType: modalSelector.confirmType,
  confirmMessage: modalSelector.confirmMessage,
  authData: authSelector.getAuth,
  redirectAuth: authSelector.redirectAuth,
  redirectGeneration: leaveGenerationSelector.redirectGeneration,
  getIsFetchingGeneration: leaveGenerationSelector.getIsFetching,
  getIsFetchingCompany: companySelector.getIsFetching,
  getIsFetchingLOB: lobSelector.getIsFetching,
  getIsFetchingEmployee: employeeSelector.getIsFetching,
  getLeaveGenerationData: leaveGenerationSelector.getLeaveGenerationData,
  editLeaveGenerationData: leaveGenerationSelector.editLeaveGenerationData,
  exportLeaveGenerationData: leaveGenerationSelector.exportLeaveGenerationData,
  exportLeaveGenerationUserData: leaveGenerationSelector.exportLeaveGenerationUserData,
  importLeaveGenerationData: leaveGenerationSelector.importLeaveGenerationData,
  getCompanyData: companySelector.getListCompany,
  getLOBData: lobSelector.getListLOB,
  getEmployeeData: employeeSelector.getListUser,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  showModal: modalAction.showModal,
  hideModal: modalAction.hideModal,
  showConfirm: modalAction.showConfirm,
  hideConfirm: modalAction.hideConfirm,
  getAuth: authAction.auth,
  resetAuth: authAction.resetAuthUser,
  getLeaveGeneration: leaveGenerationAction.getLeaveGeneration,
  resetGetLeaveGeneration: leaveGenerationAction.resetGetLeaveGeneration,
  editLeaveGeneration: leaveGenerationAction.editLeaveGeneration,
  resetEditLeaveGeneration: leaveGenerationAction.resetEditLeaveGeneration,
  exportLeaveGeneration: leaveGenerationAction.exportLeaveGeneration,
  resetExportLeaveGeneration: leaveGenerationAction.resetExportLeaveGeneration,
  exportLeaveGenerationUser: leaveGenerationAction.exportLeaveGenerationUser,
  resetExportLeaveGenerationUser: leaveGenerationAction.resetExportLeaveGenerationUser,
  importLeaveGeneration: leaveGenerationAction.importLeaveGeneration,
  resetImportLeaveGeneration: leaveGenerationAction.resetImportLeaveGeneration,
  getCompany: companyAction.getCompany,
  getLOB: lobAction.getLOB,
  getEmployee: employeeAction.getUser,
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(withLayout(LeaveGenerationPage))

const Wrapper = styled(Container)`
  padding: 0px;
`
const NewButton = styled(Button)`
  width: 150px;
  height: 50px;
  margin: 10px;
`
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
`
const OverlayWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`




// WEBPACK FOOTER //
// ./src/pages/leave-generation/index.js